var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sale-addon-profile"},[_c('div',{staticClass:"sale-addon-characters"},[(_vm.data.length > 0)?_c('draggable-dynamic-table',{ref:"saleAddonProfileCharactersList",attrs:{"options":_vm.options,"columns":_vm.columnsLabel,"data":_vm.data,"in-modal":true}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }